import 'regenerator-runtime/runtime';
import { takeEvery } from 'redux-saga/effects';
import { GlobalActions, ShopTarifierungRequestEvents } from '@ps20-frontend/shop-integration-redux';
import { ShopTarifierer, ShopTarifierungsErgebnisHandler } from '@ps20-frontend/preis-lib';
import { App } from '@ps20-frontend/frontend-models';
import { TaasJhpData } from '@ps20/bff-models';
import { ForkEffect } from '@redux-saga/core/effects';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { buildTaasJhpDataForShop } from './transformer/jhpData.transformer';

export const shopTarifierungsErgebnisHandler = new ShopTarifierungsErgebnisHandler<
  IAppState,
  TaasJhpData
>(App.JHP);
export const shopTarifierer = new ShopTarifierer({
  appId: App.JHP,
  taasDataBuilder: buildTaasJhpDataForShop,
  resultHandler: shopTarifierungsErgebnisHandler,
});

export function* shopTarifierungJHP(): Generator<ForkEffect> {
  yield takeEvery(
    ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_JHP,
    safeSaga(shopTarifierer.handleSuccess, App.JHP),
  );
  yield takeEvery(
    GlobalActions.TARIFIERE_ANGEBOT_FOR_SHOP,
    safeSaga(shopTarifierer.callTarifierung, App.JHP),
  );
}
